import React from 'react'
import './Home.css'
import { Link } from 'react-router-dom'



const Home = () => {
    return (
        <>
            <body class="index-page">

                <header id="header" class="header d-flex align-items-center fixed-top">
                    <div class="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

                        <Link to={'/'} class="logo d-flex align-items-center me-auto me-xl-0">
                            {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
                            {/* <!-- <img src="assets/img/logo.webp" alt=""/> --> */}
                            <h1 class="sitename text-white">Rkivedocs</h1>
                        </Link>

                        <nav id="navmenu" class="navmenu">
                            <ul>
                                <li><a href="#hero" class="active">Home</a></li>
                                <li><a href="#services">Features</a></li>
                                <li><a href="#contact">Contact</a></li>
                            </ul>
                            <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
                        </nav>
                        <Link class="btn-getstarted bg-white" to="/login">Login/SignUp</Link>
                    </div>
                </header>

                <main class="main">

                    {/* <!-- Hero Section --> */}
                    <section id="hero" class="hero section">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-7 content-col" data-aos="fade-up">
                                    <div class="content">
                                        <div class="agency-name">
                                            <h5>Smart Document Management System</h5>
                                        </div>

                                        <div class="main-heading">
                                            <h1>Docs <br />Buddy</h1>
                                        </div>

                                        <div class="divider"></div>

                                        <div class="description">
                                            <p>Upload your bills, Documents, manage your expenses, and gain insights — all in one place.</p>
                                        </div>

                                        <div class="cta-button">
                                            <a href="#services" class="btn">
                                                <span>EXPLORE FEATURES</span>
                                                <i class="bi bi-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5" data-aos="zoom-out">
                                    <div class="visual-content">
                                        <div class="fluid-shape">
                                            <img src="assets/img/abstract/2.png" alt="Abstract Fluid Shape" class="fluid-img" />
                                            <img src="assets/img/abstract/3.png" alt="Abstract Fluid Shape" class="fluid-img" />
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    {/* <!-- Services Section --> */}
                    <section id="services" class="services section">


                        <div class="container section-title" data-aos="fade-up">
                            <h2>Features</h2>
                            <div><span>Check Our</span> <span class="description-title">Features</span></div>
                        </div>

                        <div class="container" data-aos="fade-up" data-aos-delay="100">

                            <div class="service-header">
                                <div class="row align-items-center">
                                    <div class="col-lg-8 col-md-12">
                                        <div class="service-intro">
                                            <h2 class="service-heading">
                                                <div>Built to Simplify Your Finances</div>
                                                <div><span>Simple Experiance</span></div>
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12">
                                        <div class="service-summary">
                                            <p>
                                                Discover how our platform turns bill chaos into clean, organized insights..
                                            </p>
                                            <a href="services.html " class="service-btn text-white">
                                                View All Features
                                                <i class="bi bi-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-file-earmark-arrow-up"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Upload <span>Bills</span>
                                            </a>
                                        </h3>
                                        <p>
                                            Easily upload photos or PDFs of your bills from any device. We organize them.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-file-break"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Auto-Extract  <span>Details</span>
                                            </a>
                                        </h3>
                                        <p>
                                            Our smart system reads key info like vendor, amount, and date — no manual entry needed.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-cash-coin"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Manage  <span>Expenses</span>
                                            </a>
                                        </h3>
                                        <p>
                                            View, search, and sort all your bills in one place. Stay organized and in control.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-calendar-check"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Recurring  <span>Bills</span>
                                            </a>
                                        </h3>
                                        <p>
                                            Set up pre-recorded recurring expenses and let us log them for you automatically each month.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-graph-up"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Expense  <span>Analytics</span>
                                            </a>
                                        </h3>
                                        <p>
                                            Visualize your spending with intuitive charts. Know where your money goes.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                                    <div class="service-card position-relative z-1">
                                        <div class="service-icon">
                                            <i class="bi bi-cloud-arrow-down"></i>
                                        </div>

                                        <h3>
                                            <a href="service-details.html">
                                                Cloud  <span>Access</span>
                                            </a>
                                        </h3>
                                        <p>
                                            Securely access your records anytime, anywhere — on desktop or mobile.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </section>


                    <section id="steps" class="steps section">

                        {/* <!-- Section Title --> */}
                        <div class="container section-title" data-aos="fade-up">
                            <h2>Steps</h2>
                            <div><span>How it</span> <span class="description-title">Works</span></div>
                        </div>

                        <div class="container" data-aos="fade-up" data-aos-delay="100">

                            <div class="steps-wrapper">

                                <div class="step-item " data-aos="fade-right" data-aos-delay="200">
                                    <div class="step-content">
                                        <div class="step-icon bg-white text-dark">
                                            <i class="bi bi-lightbulb"></i>
                                        </div>
                                        <div class="step-info bg-white text-dark">
                                            <span class="step-number">Step 01</span>
                                            <h3>Sign up & log in securely</h3>
                                            <p>Create your account in seconds and access your personal dashboard.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="step-item" data-aos="fade-left" data-aos-delay="300">
                                    <div class="step-content">
                                        <div class="step-icon bg-white text-dark">
                                            <i class="bi bi-gear"></i>
                                        </div>
                                        <div class="step-info bg-white text-dark">
                                            <span class="step-number">Step 02</span>
                                            <h3>Upload or snap a picture of your bill </h3>
                                            <p>Use your phone or desktop to upload PDF or image receipts.</p>
                                            {/* <p>Developing comprehensive strategies and detailed project plans based on the initial consultation. We create actionable roadmaps with clear milestones and deliverables.</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div class="step-item" data-aos="fade-right" data-aos-delay="400">
                                    <div class="step-content">
                                        <div class="step-icon bg-white text-dark">
                                            <i class="bi bi-bar-chart"></i>
                                        </div>
                                        <div class="step-info bg-white text-dark">
                                            <span class="step-number ">Step 03</span>
                                            <h3>We extract, store, and organize it</h3>
                                            <p>Our system automatically reads key info and saves it to your records.</p>
                                            {/* <p>Executing the planned strategies with precision and agility. Our team implements solutions while maintaining constant communication and progress updates.</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div class="step-item" data-aos="fade-left" data-aos-delay="500">
                                    <div class="step-content">
                                        <div class="step-icon bg-white text-dark">
                                            <i class="bi bi-check2-circle"></i>
                                        </div>
                                        <div class="step-info bg-white text-dark">
                                            <span class="step-number ">Step 04</span>
                                            <h3>View records, analyze spending,
                                                &amp; stay ahead!</h3>
                                            <p>Track your expenses, spot trends, and manage recurring bills with ease.</p>
                                            {/* <p>Ensuring smooth deployment and providing ongoing support for implemented solutions. We monitor performance and make necessary adjustments for optimal results.</p> */}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </section>


                    {/* <section id="call-to-action" class="call-to-action section">

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="advertise-1 d-flex flex-column flex-lg-row gap-4 align-items-center position-relative">

                <div class="content-left flex-grow-1" data-aos="fade-right" data-aos-delay="200">
                    <span class="badge text-uppercase mb-2">Don't Miss!</span>
                    <h2>Revolutionize Your Digital Experience Today</h2>
                    <p class="my-4">Strategia accelerates your business growth through innovative solutions and cutting-edge technology. Join thousands of satisfied customers who have transformed their operations.</p>

                    <div class="features d-flex flex-wrap gap-3 mb-4">
                        <div class="feature-item">
                            <i class="bi bi-check-circle-fill"></i>
                            <span>Premium Support</span>
                        </div>
                        <div class="feature-item">
                            <i class="bi bi-check-circle-fill"></i>
                            <span>Cloud Integration</span>
                        </div>
                        <div class="feature-item">
                            <i class="bi bi-check-circle-fill"></i>
                            <span>Real-time Analytics</span>
                        </div>
                    </div>

                    <div class="cta-buttons d-flex flex-wrap gap-3">
                        <a href="#" class="btn btn-primary">Start Free Trial</a>
                        <a href="#" class="btn btn-outline">Learn More</a>
                    </div>
                </div>

                <div class="content-right position-relative" data-aos="fade-left" data-aos-delay="300">
                    <img src="assets/img/misc/misc-1.webp" alt="Digital Platform" class="img-fluid rounded-4" />
                    <div class="floating-card">
                        <div class="card-icon">
                            <i class="bi bi-graph-up-arrow"></i>
                        </div>
                        <div class="card-content">
                            <span class="stats-number">245%</span>
                            <span class="stats-text">Growth Rate</span>
                        </div>
                    </div>
                </div>

                <div class="decoration">
                    <div class="circle-1"></div>
                    <div class="circle-2"></div>
                </div>

            </div>

        </div>

    </section> */}




                    {/* <!-- Contact Section --> */}
                    <section id="contact" class="contact section">

                        {/* <!-- Section Title --> */}
                        <div class="container section-title" data-aos="fade-up">
                            <h2>Contact</h2>
                            <div><span>Let's</span> <span class="description-title">Connect</span></div>
                        </div>
                        {/* </div><!-- End Section Title --> */}

                        <div class="container" data-aos="fade-up" data-aos-delay="100">

                            {/* <!-- Contact Info Boxes --> */}
                            <div class="row gy-4 mb-5">
                                <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                                    <div class="contact-info-box bg-white text-dark">
                                        <div class="icon-box">
                                            <i class="bi bi-geo-alt"></i>
                                        </div>
                                        <div class="info-content">
                                            <h4>Our Address</h4>
                                            <p>1842 Maple Avenue, Portland, Oregon 97204</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                                    <div class="contact-info-box bg-white text-dark">
                                        <div class="icon-box">
                                            <i class="bi bi-envelope"></i>
                                        </div>
                                        <div class="info-content">
                                            <h4>Email Address</h4>
                                            {/* <p>info@example.com</p> */}
                                            <p>support@mtsget.com</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                                    <div class="contact-info-box bg-white text-dark">
                                        <div class="icon-box">
                                            <i class="bi bi-headset"></i>
                                        </div>
                                        <div class="info-content">
                                            <h4>Hours of Operation</h4>
                                            <p>Sunday-Fri: 9 AM - 6 PM</p>
                                            <p>Saturday: 9 AM - 4 PM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* <!-- Google Maps (Full Width) --> */}
                        {/* <div class="map-section" data-aos="fade-up" data-aos-delay="200">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d48389.78314118045!2d-74.006138!3d40.710059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a22a3bda30d%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1676961268712!5m2!1sen!2sus" width="100%" height="500" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div> */}

                        {/* <!-- Contact Form Section (Overlapping) --> */}
                        {/* <div class="container form-container-overlap">
            <div class="row justify-content-center" data-aos="fade-up" data-aos-delay="300">
                <div class="col-lg-10">
                    <div class="contact-form-wrapper">
                        <h2 class="text-center mb-4">Get in Touch</h2>

                        <form action="forms/contact.php" method="post" class="php-email-form">
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="input-with-icon">
                                            <i class="bi bi-person"></i>
                                            <input type="text" class="form-control" name="name" placeholder="First Name" required="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="input-with-icon">
                                            <i class="bi bi-envelope"></i>
                                            <input type="email" class="form-control" name="email" placeholder="Email Address" required="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="input-with-icon">
                                            <i class="bi bi-text-left"></i>
                                            <input type="text" class="form-control" name="subject" placeholder="Subject" required="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="input-with-icon">
                                            <i class="bi bi-chat-dots message-icon"></i>
                                            <textarea class="form-control" name="message" placeholder="Write Message..." style={{ height: '180px' }} required=""></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="loading">Loading</div>
                                    <div class="error-message"></div>
                                    <div class="sent-message">Your message has been sent. Thank you!</div>
                                </div>

                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-primary btn-submit">SEND MESSAGE</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div> */}

                    </section>

                </main>

                <footer id="footer" class="footer">

                    <div class="container footer-top">
                        <div class="row gy-4">
                            <div class="col-lg-5 col-md-12 footer-about">
                                <a href="index.html" class="logo d-flex align-items-center">
                                    <span class="sitename">Bill Buddy</span>
                                </a>
                                <p>Upload your bills, manage your expenses, and gain insights — all in one place.</p>
                                {/* <p>Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus.</p> */}
                                <div class="social-links d-flex mt-4">
                                    <a href=""><i class="bi bi-twitter-x"></i></a>
                                    <a href=""><i class="bi bi-facebook"></i></a>
                                    <a href=""><i class="bi bi-instagram"></i></a>
                                    <a href=""><i class="bi bi-linkedin"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-2 col-6 footer-links">
                                <h4>Useful Links</h4>
                                <ul>
                                    <li><a href="#hero">Home</a></li>
                                    <li><a href="#services">Services</a></li>
                                    <li><a href="#">Terms of service</a></li>
                                    <li><a href="#">Privacy policy</a></li>
                                </ul>
                            </div>


                            <div class="col-lg-3 col-md-12 footer-contact text-center text-md-start">
                                <h4>Contact Us</h4>
                                <p>A108 Adam Street</p>
                                <p>New York, NY 535022</p>
                                <p>United States</p>
                                <p class="mt-4"><strong>Phone:</strong> <span>+1 5589 55488 55</span></p>
                                <p><strong>Email:</strong> <span>support@mtsget.com</span></p>
                            </div>

                        </div>
                    </div>



                </footer>


                <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>


            </body>

        </>
    )
}

export default Home